import { Mutation } from 'vuex';
import { IModuleState } from './types';

// 列表
export const setUeItems: Mutation<IModuleState> = (state, payload) => {
  state.list.data = payload.data;
  state.list.loading = !!payload.loading;
};

// confirm 弹窗
export const setConfirm: Mutation<IModuleState> = (state, payload) => {
  state.confirm.visible = !!payload.visible;
  state.confirm.loading = !!payload.loading;
  state.confirm.title = payload.title || '';
  state.confirm.content = payload.content || '';
};

export const setLoading: Mutation<IModuleState> = (state, payload) => {
  state.loading = payload;
};
